<div class="table-row">
  <selfai-platform-pipeline-variables-tree
    [workflowId]="data.workflowId"
    [includeGlobal]="data.includeGlobal"
    [userPermissions]="userPermissions$ | async"
  ></selfai-platform-pipeline-variables-tree>
</div>
